export default __webpack_public_path__ + "static/media/email.f8f1aeae.svg";